<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center" style="font-size: 35px;">
                DISCLOSURE TO SURPLUS LINE INSURED
              <br>
                <strong> IMPORTANT NOTICE </strong>
              </p>

            </article>
            <article class="input-section">
              <div>
                <p class="mb-3 ca-sl-disclosure" align="left">
                    1. THE INSURANCE POLICY THAT YOU ARE APPLYING TO PURCHASE
                    IS BEING ISSUED BY AN INSURER THAT IS NOT LICENSED BY THE
                    STATE OF CALIFORNIA. THESE COMPANIES ARE CALLED
                    “NONADMITTED” OR “SURPLUS LINE” INSURERS.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  2. THE INSURER IS NOT SUBJECT TO THE FINANCIAL SOLVENCY
                  REGULATION AND ENFORCEMENT THAT APPLY TO CALIFORNIA
                  LICENSED INSURERS.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  3. THE INSURER DOES NOT PARTICIPATE IN ANY OF THE INSURANCE
                  GUARANTEE FUNDS CREATED BY CALIFORNIA LAW. THEREFORE,
                  THESE FUNDS WILL NOT PAY YOUR CLAIMS OR PROTECT YOUR
                  ASSETS IF THE INSURER BECOMES INSOLVENT AND IS UNABLE TO
                  MAKE PAYMENTS AS PROMISED.</p>

                <p class="mb-3 ca-sl-disclosure" align="left">
                  4. THE INSURER SHOULD BE LICENSED EITHER AS A FOREIGN
                  INSURER IN ANOTHER STATE IN THE UNITED STATES OR AS A NON-
                  UNITED STATES (ALIEN) INSURER. YOU SHOULD ASK QUESTIONS
                  OF YOUR INSURANCE AGENT, BROKER, OR “SURPLUS LINE”
                  BROKER OR CONTACT THE CALIFORNIA DEPARTMENT OF
                  INSURANCE AT THE FOLLOWING TOLL-FREE NUMBER, 1-800-927-
                  4357 OR INTERNET WEB SITE, <a href="http://WWW.INSURANCE.CA.GOV" target="_blank">WWW.INSURANCE.CA.GOV</a>. ASK
                  WHETHER OR NOT THE INSURER IS LICENSED AS A FOREIGN OR
                  NON-UNITED STATES (ALIEN) INSURER AND FOR ADDITIONAL
                  INFORMATION ABOUT THE INSURER. YOU MAY ALSO VISIT THE
                  NAIC’S INTERNET WEB SITE AT <a href="http://WWW.NAIC.ORG" target="_blank">WWW.NAIC.ORG</a>. THE NAIC – THE
                  NATIONAL ASSOCIATON OF INSURANCE COMMISSIONERS – THE
                  REGULATORY SUPPORT ORGANIZATION CREATED AND GOVERNED
                  BY THE CHIEF INSURANCE REGULATORS IN THE UNITED STATES.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  5. FOREIGN INSURERS SHOULD BE LICENSED BY A STATE IN THE
                  UNITED STATES AND YOU MAY CONTACT THAT STATE’S
                  DEPARTMENT OF INSURANCE TO OBTAIN MORE INFORMATION
                  ABOUT THAT INSURER. YOU CAN FIND A LINK TO EACH STATE
                  FROM THIS NAIC INTERNET WEBSITE:
                  <a href="HTTPS://NAIC.ORG/STATE_WEB_MAP.HTM" target="_blank">HTTPS://NAIC.ORG/STATE_WEB_MAP.HTM</a>.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  6. FOR NON-UNITED STATES (ALIEN) INSURERS, THE INSURER
                  SHOULD BE LICENSED BY A COUNTRY OUTSIDE OF THE UNITED
                  STATES AND SHOULD BE ON THE NAIC’S INTERNATIONAL
                  INSURERS DEPARTMENT (IID) LISTING OF APPROVED
                  NONADMITTED NON-UNITED STATES INSURERS. ASK YOUR AGENT,
                  BROKER, OR “SURPLUS LINE” BROKER TO OBTAIN MORE
                  INFORMATION ABOUT THAT INSURER.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  7. CALIFORNIA MAINTAINS A LIST OF APPROVED “SURPLUS LINE”
                  INSURERS (LASLI). ASK YOUR AGENT OR BROKER IF THE INSURER
                  IS ON THAT LIST, OR VIEW THAT LIST AT THE INTERNET WEB SITE
                  OF THE CALIFORNIA DEPARTMENT OF INSURANCE,
                  <a href="HTTP://WWW.INSURANCE.CA.GOV/01-CONSUMERS/120-COMPANY/07-
                  LASLI/LASLI.CFM" target="_blank">WWW.INSURANCE.CA.GOV/01-CONSUMERS/120-COMPANY/07-
                  LASLI/LASLI.CFM</a>.</p>
                <p class="mb-3 ca-sl-disclosure" align="left">
                  8. IF YOU, AS THE APPLICANT, REQUIRED THAT THE INSURANCE
                  POLICY YOU HAVE PURCHASED BE EFFECTIVE IMMEDIATELY,
                  EITHER BECAUSE EXISTING COVERAGE WAS GOING TO LAPSE
                  WITHIN TWO BUSINESS DAYS OR BECAUSE YOU WERE REQUIRED
                  TO HAVE COVERAGE WITHIN TWO BUSINESS DAYS, AND YOU DID
                  NOT RECEIVE THIS DISCLOSURE FORM AND A REQUEST FOR YOUR
                  SIGNATURE UNTIL AFTER COVERAGE BECAME EFFECTIVE, YOU
                  HAVE THE RIGHT TO CANCEL THIS POLICY WITHIN FIVE DAYS OF
                  RECEIVING THIS DISCLOSURE. IF YOU CANCEL COVERAGE, THE
                  PREMIUM WILL BE PRORATED ANY BROKER’S FEE CHARGED FOR
                  THIS INSURANCE WILL BE RETURNED TO YOU.</p>
              </div>
            </article>
            <article class="form-heading form-section review-sign">
              <div class="row mr-0 ml-0" style="align-content: center">
                <div class="col-md-5">
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="notice-form-date">Date:</label>
                    <input
                      id="date"
                      type="date"
                      class="orep-text-input notice-input text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </section>
                </div>
                <div class="col-md-5">
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="notice-form-date">INSURED:</label>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="slDisclosureSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="quote.slDisclosureSignature"
                    >
                  </section>
                </div>
              </div>
            <div class="input-section">
              <p>D‐1 (Effective January 1, 2020)</p>
            </div>
            </article>

          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'property-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "property-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

